var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "checkout-payment-form" }, [
    _c("div", { staticClass: "checkout-form__group" }, [
      _c(
        "div",
        {
          staticClass: "checkout-form__field",
          class: { "form__field--error": _vm.showErrorClass("accountHolder") },
        },
        [
          _c("label", { attrs: { for: "sepa-accountHolder" } }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("checkout.payment.sepa.accountHolder")) +
                _vm._s(_vm.$t("global.forms.required")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.dto.accountHolder,
                expression: "dto.accountHolder",
                modifiers: { trim: true },
              },
            ],
            attrs: {
              id: "sepa-accountHolder",
              name: "accountHolder",
              type: "text",
            },
            domProps: { value: _vm.dto.accountHolder },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.dto, "accountHolder", $event.target.value.trim())
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "checkout-form__field",
          class: { "form__field--error": _vm.showErrorClass("iban") },
        },
        [
          _c("label", { attrs: { for: "sepa-iban" } }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("checkout.payment.sepa.iban")) +
                _vm._s(_vm.$t("global.forms.required")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("input", {
            attrs: {
              id: "sepa-iban",
              name: "iban",
              type: "text",
              placeholder: "DE12 3456 7891 0111 2131 41",
            },
            domProps: { value: _vm.dto.iban },
            on: {
              input: function ($event) {
                _vm.dto.iban = $event.target.value.toUpperCase().trim()
              },
            },
          }),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "checkout-form__group" }, [
      _c(
        "div",
        {
          staticClass: "checkout-form__field",
          class: { "form__field--error": _vm.showErrorClass("bankName") },
        },
        [
          _c("label", { attrs: { for: "sepa-bankName" } }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("checkout.payment.sepa.bankName")) +
                _vm._s(_vm.$t("global.forms.required")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.dto.bankName,
                expression: "dto.bankName",
                modifiers: { trim: true },
              },
            ],
            attrs: { id: "sepa-bankName", name: "bankName", type: "text" },
            domProps: { value: _vm.dto.bankName },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.dto, "bankName", $event.target.value.trim())
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "checkout-form__field",
          class: { "form__field--error": _vm.showErrorClass("bic") },
        },
        [
          _c("label", { attrs: { for: "sepa-bic" } }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("checkout.payment.sepa.bic")) +
                _vm._s(_vm.$t("global.forms.required")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("input", {
            attrs: {
              id: "sepa-bic",
              name: "bic",
              type: "text",
              placeholder: "ABCDEF1AXXX",
            },
            domProps: { value: _vm.dto.bic },
            on: {
              input: function ($event) {
                _vm.dto.bic = $event.target.value.toUpperCase().trim()
              },
            },
          }),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "form__group form__group--checkbox",
        class: { "form__field--error": _vm.showErrorClass("consent") },
      },
      [
        _c(
          "label",
          { staticClass: "form__label", attrs: { for: "sepa-consent" } },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.dto.consent,
                  expression: "dto.consent",
                },
              ],
              attrs: {
                id: "sepa-consent",
                name: "consent",
                required: "",
                type: "checkbox",
              },
              domProps: {
                checked: Array.isArray(_vm.dto.consent)
                  ? _vm._i(_vm.dto.consent, null) > -1
                  : _vm.dto.consent,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.dto.consent,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && _vm.$set(_vm.dto, "consent", $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.dto,
                          "consent",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.dto, "consent", $$c)
                  }
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "checkbox-label icon icon-check" }),
            _vm._v(" "),
            _c("span", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("checkout.payment.sepa.consent")),
              },
            }),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }